{
  "alert": "Ostrzeżenie",
  "dismiss": "Zignoruj"
}
